<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#assigned" active>Assigned</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Assigned</h1>
    <p>Access tasks assigned to you.</p>
    <hr>
    <div class="task-container">
      <div v-if="showPlaceholderImage && !hideWhenInitialLoad" class="no-task-container">
        <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
               alt="No task picture"></b-img>
        <h2>No assigned task</h2>
        <p>Task assigned to you will be shown here</p>
      </div>
      <regular-with-origin-task-cell v-for="assignedTask in assignedTaskDocuments" :key="assignedTask.taskId"
                                     :task-details="assignedTask"></regular-with-origin-task-cell>
    </div>
  </div>
</template>

<script>
  import RegularWithOriginTaskCellTaskCell from "../table_cells/task_cells/RegularWithOriginTaskCell"
  import {mapActions, mapGetters} from "vuex";
  import {db} from "../../main";

  export default {
    data() {
      return {
        showPlaceholderImage: null,
        hideWhenInitialLoad: true,
        assignedTaskDocuments: null
      }
    },
    components: {
      regularWithOriginTaskCell: RegularWithOriginTaskCellTaskCell
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      getSortedAssignedTaskData(sortProperties) {
        if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('taskCreationTime', 'asc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('taskCreationTime', 'desc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('priority', 'asc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('priority', 'desc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      getFilteredAssignedTaskData(filterProperties) {
        if (filterProperties.filterTypeSelected === 'None') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .orderBy('taskCreationTime', 'asc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .where('completed', '==', true)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .where('completed', '==', true)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .where('completed', '==', false)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'assignedTaskDocuments',
            db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .where('completed', '==', false)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.assignedTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      }
    },
    computed: {
      ...mapGetters([
        "sortTaskListProperties",
        "filterTaskListProperties"
      ])
    },
    watch: {
      assignedTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImage = this.assignedTaskDocuments.length === 0
      },
      sortTaskListProperties(newSortProperties, oldSortProperties) {
        this.getSortedAssignedTaskData(newSortProperties)
      },
      filterTaskListProperties(newFilterProperties, oldFilterProperties) {
        this.getFilteredAssignedTaskData(newFilterProperties)
      }
    },
    mounted() {
      this.getSortedAssignedTaskData({
        sortTypeSelected: 'Creation time',
        sortDirectionSelected: 'Ascending'
      })
    }
  }
</script>

<style scoped>
  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .task-container {
    height: 69vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
